export const REACT_APP_API_URL = "https://api.myaltimate.com/";
// export const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
export const VSCODE_MARKETPLACE_API_URL =
  "https://marketplace.visualstudio.com/_apis/public/gallery/extensionquery";
